module.exports = __webpack_public_path__ + "img/tile-type-desktop_cn.bf86070.jpg";